import { render, staticRenderFns } from "./DealCommentsDialog.vue?vue&type=template&id=6dd04298&"
import script from "./DealCommentsDialog.vue?vue&type=script&lang=ts&"
export * from "./DealCommentsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports